import { MapPin, Video, MessageCircle } from "lucide-react";
import { LogoFull } from "./Logo";
import { waLink, WA_MESSAGES, WHATSAPP_DISPLAY } from "../lib/whatsapp";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-amber-500/15 bg-[#0A111D] py-14">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <LogoFull />
          <p className="text-xs text-slate-500 leading-relaxed mt-5 max-w-xs">
            Estratégia jurídica, blindagem de bens e sigilo absoluto para a preservação do seu
            patrimônio em divórcios de alta complexidade.
          </p>
        </div>

        <div>
          <p className="font-mono-num text-[10px] uppercase tracking-[0.25em] text-amber-400/80 mb-5">
            Onde atendemos
          </p>
          <ul className="space-y-3.5 text-sm text-slate-400">
            <li className="flex items-start gap-3">
              <Video className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
              Atendimento digital por videochamada em todo o Brasil
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
              Atendimento presencial em Naviraí/MS, com hora marcada
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
              <a
                href={waLink(WA_MESSAGES.float)}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-amber-200 transition-colors"
                data-testid="footer-whatsapp-link"
              >
                WhatsApp {WHATSAPP_DISPLAY}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-mono-num text-[10px] uppercase tracking-[0.25em] text-amber-400/80 mb-5">
            Navegação
          </p>
          <ul className="space-y-3 text-sm text-slate-400">
            {[
              ["Riscos ocultos", "#riscos"],
              ["Simulador patrimonial", "#simulador"],
              ["Soluções", "#solucoes"],
              ["Modalidades de divórcio", "#modalidades"],
              ["Sobre a TSS", "#sobre"],
              ["Depoimentos", "#depoimentos"],
              ["Perguntas frequentes", "#faq"],
              ["Política de Privacidade (LGPD)", "/privacidade"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="hover:text-amber-200 transition-colors">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800/80 mt-12 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[11px] text-slate-600">
          © {new Date().getFullYear()} TSS — ADVOGADOS. Todos os direitos reservados.
        </p>
        <p className="text-[11px] text-slate-600">
          Conteúdo informativo. Não constitui aconselhamento jurídico individualizado.
        </p>
      </div>
    </div>
  </footer>
);
